import { CreateOrUpdateFocusOkResponseBody, FocusDTO, FocusTabDTO } from "@/js/api/focus";
import { ResourceType, SelectedResource } from "./FocusResourcePicker/SelectedFocusResources";

export function transformSelectedResourcesToMatchAPIContract(selectedResources: SelectedResource[]): FocusTabDTO[] {
	return selectedResources.map((resource) => {
		return {
			id: resource.id,
			url: resource.resourceType === ResourceType.Url ? resource.resourceValue : undefined,
			signature: resource.resourceType === ResourceType.Signature ? resource.resourceValue : undefined,
			openTab: resource.openTab,
		};
	});
}

export function transformUpsertResonseToFocusItem(response: CreateOrUpdateFocusOkResponseBody): FocusDTO {
	return {
		id: response.id,
		name: response.name || "",
		focusTabs: response.focusTabs || [],
		tabsLocked: response.tabsLocked || false,
		lastUsed: response.lastUsed || 0,
		createdAt: response.createdAt || 0,
		active: response.active || false,
		studentIds: response.studentIds || [],
	};
}
